import { forwardRef } from 'react';
import { Typography } from '../../../ui';

import { ListBoxItemRenderProps } from 'react-aria-components';
import { IconCheck } from '@maia/icons';
import { Avatar } from '../../../atoms/avatar/avatar';
import { AvatarStyleVariants } from '../../../atoms/avatar/variants';

type Props = {
  label: string;
  variant: AvatarStyleVariants['variant'];
  avatar: {
    initials: string;
    src?: string;
    alt?: string;
  };
  className?: string;
} & Partial<ListBoxItemRenderProps>;

export const DropdownOptionAvatar = forwardRef<HTMLDivElement, Props>(
  ({ label, avatar, isSelected, isFocusVisible, variant }, ref) => {
    return (
      <div
        className="flex flex-row items-center space-x-8 rounded-4 p-12 hover:bg-primary50"
        ref={ref}
      >
        <Avatar size={16} variant={variant} {...avatar} />
        <Typography
          variant="body-xs"
          weight={isSelected || isFocusVisible ? 'medium' : 'regular'}
          className="flex-1 text-grayscale600"
        >
          {label}
        </Typography>

        {isSelected && (
          <IconCheck className="min-w-16 w-16 h-16 ml-8 fill-grayscale600" />
        )}
      </div>
    );
  },
);

DropdownOptionAvatar.displayName = 'DropdownOptionAvatar';
